import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { WebcamModule } from 'ngx-webcam';
//import { AuthGuardService } from './servicios/auth-guard.service';
import { TopBarComComponent } from './componentes/top-bar-com/top-bar-com.component';
import { FooterElemComponent } from './elementos/footer-elem/footer-elem.component';
import { InicioComComponent } from './componentes/inicio-com/inicio-com.component';
import { ConsultaUsrComComponent } from './componentes/consulta-usr-com/consulta-usr-com.component';
import { ConsultaPacComComponent } from './componentes/consulta-pac-com/consulta-pac-com.component';
import { UsuarioComComponent } from './componentes/usuario-com/usuario-com.component';
import { PacienteComComponent } from './componentes/paciente-com/paciente-com.component';
import { PacienteComDatosComponent } from './componentes/paciente-com-datos/paciente-com-datos.component';
import { PacienteComAntecComponent } from './componentes/paciente-com-antec/paciente-com-antec.component';
import { PacienteComHCComponent } from './componentes/paciente-com-hc/paciente-com-hc.component';
import { PacienteComConsultaComponent } from './componentes/paciente-com-consulta/paciente-com-consulta.component';
import { PlanComComponent } from './componentes/plan-com/plan-com.component';
import { PlanComPlanesComponent } from './componentes/plan-com-planes/plan-com-planes.component';
import { PlanComMiplanComponent } from './componentes/plan-com-miplan/plan-com-miplan.component';
import { PlanComFacturasComponent } from './componentes/plan-com-facturas/plan-com-facturas.component';
import { ConsultaCitComCitaComponent } from './componentes/consulta-cit-com-cita/consulta-cit-com-cita.component';
import { ConsultaFacComComponent } from './componentes/consulta-fac-com/consulta-fac-com.component';
import { ConsultaCitComComponent } from './componentes/consulta-cit-com/consulta-cit-com.component';
import { ConsultaActComComponent } from './componentes/consulta-act-com/consulta-act-com.component';
import { FacturaComComponent } from './componentes/factura-com/factura-com.component';
import { FacturaComCobroComponent } from './componentes/factura-com-cobro/factura-com-cobro.component';
import { MovCajaComComponent } from './componentes/movcaja-com/movcaja-com.component';
import { ConsultaArtComComponent } from './componentes/consulta-art-com/consulta-art-com.component';
import { ArticuloComComponent } from './componentes/articulo-com/articulo-com.component';
import { ConsultaAtiendeComComponent } from './componentes/consulta-atiende-com/consulta-atiende-com.component';
import { AtiendeComComponent } from './componentes/atiende-com/atiende-com.component';
import { ConsultaEntPresComComponent } from './componentes/consulta-entpres-com/consulta-entpres-com.component';
import { EntPresComComponent } from './componentes/entpres-com/entpres-com.component';
import { ConsultaEntDiagComComponent } from './componentes/consulta-entdiag-com/consulta-entdiag-com.component';
import { EntDiagComComponent } from './componentes/entdiag-com/entdiag-com.component';
import { ConsultaEntProcComComponent } from './componentes/consulta-entproc-com/consulta-entproc-com.component';
import { EntProcComComponent } from './componentes/entproc-com/entproc-com.component';
import { OfflineElemComponent } from './elementos/offline-elem/offline-elem.component';
import { LoadingElemComponent } from './elementos/loading-elem/loading-elem.component';
import { TarjinicioElemComponent } from './elementos/tarjinicio-elem/tarjinicio-elem.component';
import { MsgboxElemComponent } from './elementos/msgbox-elem/msgbox-elem.component';
import { PictakeElemComponent } from './elementos/pictake-elem/pictake-elem.component';
import { PicloadElemComponent } from './elementos/picload-elem/picload-elem.component';
import { PicshowElemComponent } from './elementos/picshow-elem/picshow-elem.component';
import { PreviewElemComponent } from './elementos/preview-elem/preview-elem.component';
import { ComboElemComponent } from './elementos/combo-elem/combo-elem.component';
import { DatepickElemComponent } from './elementos/datepick-elem/datepick-elem.component';
import { DropdownElemComponent } from './elementos/dropdown-elem/dropdown-elem.component';
import { SelectboxElemComponent } from './elementos/selectbox-elem/selectbox-elem.component';
import { PlacetopayElemComponent } from './elementos/placetopay-elem/placetopay-elem.component';
import { EvitaDobleClicDirectiva } from './directivas/evitadobleclic-directiva';
import { SwipeDirectiva } from './directivas/swipe-directiva';
import { AutoResizeDirectiva } from './directivas/autoresizetextarea-directiva';
import { ActivacionComComponent } from './componentes/activacion-com/activacion-com.component';
import { ConfigComComponent } from './componentes/config-com/config-com.component';

@NgModule({
  imports: [
    CommonModule,               //si no pongo esto, da errores al compilar el HTML en ngStyle, ngFor, etc 
    RouterModule,               //si no pongo esto, da errores al compilar el HTML en routerLink
    ReactiveFormsModule,        //si no pongo esto, da errores al compilar el HTML en forms
    FormsModule,                //sin esto, da error en pictake (y en picshow?) en [(ngModel)]
    WebcamModule
  ],
  declarations: [
    FooterElemComponent,
    TopBarComComponent,
    InicioComComponent,
    ConsultaUsrComComponent,
    ConsultaPacComComponent,
    UsuarioComComponent,
    PacienteComComponent,
    PacienteComDatosComponent,
    PacienteComAntecComponent,
    PacienteComHCComponent,
    PacienteComConsultaComponent,
    PlanComComponent,
    PlanComPlanesComponent,
    PlanComMiplanComponent,
    PlanComFacturasComponent,
    ConsultaCitComCitaComponent,
    ConsultaFacComComponent,
    ConsultaCitComComponent,
    ConsultaActComComponent,
    FacturaComComponent,
    FacturaComCobroComponent,
    MovCajaComComponent,
    ConsultaArtComComponent,
    ArticuloComComponent,
    ConsultaAtiendeComComponent,
    AtiendeComComponent,
    ConsultaEntPresComComponent,
    EntPresComComponent,
    ConsultaEntDiagComComponent,
    EntDiagComComponent,
    ConsultaEntProcComComponent,
    EntProcComComponent,
    OfflineElemComponent,
    LoadingElemComponent,
    TarjinicioElemComponent,
    MsgboxElemComponent,
    PictakeElemComponent,
    PicloadElemComponent,
    PicshowElemComponent,
    PreviewElemComponent,
    ComboElemComponent,
    DatepickElemComponent,
    DropdownElemComponent,
    SelectboxElemComponent,
    PlacetopayElemComponent,
    EvitaDobleClicDirectiva,
    SwipeDirectiva,
    AutoResizeDirectiva,
    ActivacionComComponent,
    ConfigComComponent
  ],
  exports: [
    //RouterModule,             //no hace falta, no hay ruteo en este módulo
    FooterElemComponent,
    TopBarComComponent,
    InicioComComponent,
    ConsultaUsrComComponent,
    ConsultaPacComComponent,
    UsuarioComComponent,
    PacienteComComponent,
    PacienteComDatosComponent,
    PacienteComAntecComponent,
    PacienteComHCComponent,
    PacienteComConsultaComponent,
    PlanComComponent,
    PlanComPlanesComponent,
    PlanComMiplanComponent,
    PlanComFacturasComponent,
    ConsultaCitComCitaComponent,
    ConsultaFacComComponent,
    ConsultaCitComComponent,
    ConsultaActComComponent,
    FacturaComComponent,
    FacturaComCobroComponent,
    MovCajaComComponent,
    ConsultaArtComComponent,
    ArticuloComComponent,
    ConsultaAtiendeComComponent,
    AtiendeComComponent,
    ConsultaEntPresComComponent,
    EntPresComComponent,
    ConsultaEntDiagComComponent,
    EntDiagComComponent,
    ConsultaEntProcComComponent,
    EntProcComComponent,
    OfflineElemComponent,
    LoadingElemComponent,
    TarjinicioElemComponent,
    MsgboxElemComponent,
    PictakeElemComponent,
    PicloadElemComponent,
    PicshowElemComponent,
    PreviewElemComponent,
    ComboElemComponent,
    DatepickElemComponent,
    DropdownElemComponent,
    SelectboxElemComponent,
    PlacetopayElemComponent,
    EvitaDobleClicDirectiva,
    SwipeDirectiva,
    AutoResizeDirectiva,
    ActivacionComComponent,
    ConfigComComponent
  ],
  providers: []
})
export class ComunesModule { }